import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import EditIcon from '@mui/icons-material/Edit';
// import { Timeline, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from '@mui/lab';
import {
  Box,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Divider,
  // IconButton,
  // ListItemText,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from '@mui/material';
import { Grid, Typography } from '@mui/material';
import { Button } from '@mui/material';
// import { Stack } from '@mui/system';
import { url } from 'config/config';
import moment from 'moment';
import { enqueueSnackbar } from 'notistack';
import CustomerCreate from 'components/SS/addCustomer.jsx';
import FollowupCreate from 'components/SS/addFollwUp.jsx';
import FollowupEdit from 'components/SS/editFollowup.jsx';
import IconifyIcon from 'components/base/IconifyIcon.jsx';
import { get } from '../../api/index.js';

const EnquiryInfo = () => {
  const { state } = useLocation();
  const [data, setData] = useState(null);
  const [tab, setTab] = useState(0);
  const [open, setOpen] = useState(false);
  const [customerOpen, setCustomerOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const [edit, setEdit] = useState(null);

  const handleClick = (state) => {
    setOpen(true);
    selected;
    setSelected(state);
  };

  const fetchData = async () => {
    try {
      const res = await get(`users/get_enquiry/${state._id}`);
      if (res.status === 200) {
        setData(res.data[0]);
      } else {
        enqueueSnackbar(res.message || 'Error while fetching enquiry');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [state]);

  if (!data)
    return (
      <Box
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}
      >
        <CircularProgress />
      </Box>
    );

  return (
    <Box p={3}>
      {/* HEADER CARD */}
      <Card
        background={1}
        sx={{
          mb: 3,
          borderRadius: 3,
          border: '1px solid #e5e7eb',
        }}
      >
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={7}>
              <Typography variant="h5" fontWeight={600}>
                {data.name}
              </Typography>
              <Typography color="text.secondary">
                {data.mobile} {data?.email || ''}
              </Typography>
            </Grid>

            <Grid item xs={2} textAlign="right">
              <Chip
                label={data.status}
                color={data.status === 'Accepted' ? 'success' : 'warning'}
              />
            </Grid>
            <Grid item xs={3} textAlign="right" sx={{ flex: 1 }}>
              <Button variant="soft" shape="square" color="neutral" sx={{ gap: 0.5, p: 1 }}>
                <IconifyIcon icon="material-symbols:add-2-rounded" />
                <Box
                  component="span"
                  sx={{ display: { xs: 'none', sm: 'block' } }}
                  onClick={() => setCustomerOpen(!customerOpen)}
                >
                  On Board
                </Box>
              </Button>
            </Grid>
          </Grid>

          <Divider sx={{ my: 1 }} />

          <Grid container spacing={4}>
            <Grid item xs={3}>
              <Typography variant="caption">City</Typography>
              <Typography fontWeight={500}>{data.city?.name}</Typography>
            </Grid>

            <Grid item xs={3}>
              <Typography variant="caption">Capacity</Typography>
              <Typography fontWeight={500}>{data.requirementCapacity} kW</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="caption">Solar Type</Typography>
              <Typography fontWeight={500}>{data.solarType || ''} </Typography>
            </Grid>

            <Grid item xs={3}>
              <Typography variant="caption">Property Type</Typography>
              <Typography fontWeight={500}>{data.typeOfProperty}</Typography>
            </Grid>

            <Grid item xs={3}>
              <Typography variant="caption">Created On</Typography>
              <Typography fontWeight={500}>
                {new Date(data.createdAt).toLocaleDateString()}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="caption">Surveyor</Typography>
              <Typography fontWeight={500}>
                {`${data.fieldSales?.firstName} ${data.fieldSales?.lastName}`}
              </Typography>
            </Grid>

            <Grid item xs={3}>
              <Typography variant="caption">Sales Manager</Typography>
              <Typography fontWeight={500}>
                {`${data.assignManager?.firstName} ${data.assignManager?.lastName}`}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={{ my: 1 }} />
          <Grid item xs={3}>
            <Typography variant="caption">Address</Typography>
            <Typography fontWeight={500}>{data.address}</Typography>
          </Grid>
        </CardContent>
      </Card>

      {/* TABS */}
      <Card sx={{ borderRadius: 3 }}>
        <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ px: 2, pt: 2 }}>
          {/* <Tab label="Info" /> */}
          <Tab label="Quotation" />
          <Tab label="Follow Up" />
        </Tabs>

        <Divider />

        <Box p={3}>
          {/* {tab === 0 && <InfoTab data={data} />} */}
          {tab === 0 && <QuotationTab quotations={data.quotations} />}
          {tab === 1 && (
            <FollowUpTab
              followUps={data.followUp}
              open={open}
              setOpen={setOpen}
              handleClick={handleClick}
              openEdit={openEdit}
              setOpenEdit={setOpenEdit}
              setEdit={setEdit}
            />
          )}
        </Box>
      </Card>
      <FollowupCreate open={open} setOpen={setOpen} enquiry={state} fetchData={fetchData} />
      <FollowupEdit
        open={openEdit}
        setOpen={setOpenEdit}
        enquiry={state}
        followUp={edit}
        fetchData={fetchData}
      />
      <CustomerCreate open={customerOpen} setOpen={setCustomerOpen} enquiry={state} />
    </Box>
  );
};

export default EnquiryInfo;

export const InfoTab = ({ data }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <Card sx={{ borderRadius: 2 }}>
          <CardContent>
            <Typography variant="subtitle1" fontWeight={600}>
              Customer Details
            </Typography>

            <Typography>Name: {data.name}</Typography>
            <Typography>Mobile: {data.mobile}</Typography>
            <Typography>Email: {data?.email || ''}</Typography>
            <Typography>Address: {data.address}</Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={6}>
        <Card sx={{ borderRadius: 2 }}>
          <CardContent>
            <Typography variant="subtitle1" fontWeight={600}>
              Assignment
            </Typography>

            <Typography>
              Manager: {data.assignManager?.firstName} {data.assignManager?.lastName}
            </Typography>

            <Typography>
              Field Sales: {data.fieldSales?.firstName} {data.fieldSales?.lastName}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export const QuotationTab = ({ quotations }) => {
  return quotations?.length ? (
    <Grid container spacing={2}>
      {quotations.map((q, index) => (
        <Grid item xs={12} sm={6} md={3} key={q._id}>
          {/* md={3} → 12 / 3 = 4 cards per row */}
          <Paper
            sx={{
              p: 2,
              height: '100%',
              borderLeft: '4px solid',
              borderColor: q.customerRecive ? 'success.main' : 'warning.main',
              borderRadius: 2,
            }}
          >
            <Grid container alignItems="center">
              <Grid item xs={6} sx={{ flex: 1 }}>
                <Typography fontWeight={600} noWrap>
                  {index + 1}. Quotation-{q.name}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {moment(q.createdAt).format('DD/MM/YYYY hh:mm A')}
                </Typography>
              </Grid>

              <Grid item xs={2} textAlign="right">
                <Chip
                  label={q.customerRecive ? 'Send' : 'Pending'}
                  color={q.customerRecive ? 'success' : 'warning'}
                  size="small"
                  sx={{ ml: 3, mr: 2 }}
                />
                <Button size="small" variant="outlined" href={`${url}${q.url}`} target="_blank">
                  View
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      ))}
    </Grid>
  ) : (
    <Typography>No quotations found</Typography>
  );
};

export const FollowUpTab = ({ followUps, open, setOpen, openEdit, setOpenEdit, setEdit }) => {
  return (
    <Box>
      <Box sx={{ display: 'flex', flex: 1, justifyContent: 'end', mb: 2 }}>
        <Button variant="soft" shape="square" color="neutral" sx={{ gap: 0.5, p: 1 }}>
          <IconifyIcon icon="material-symbols:add-2-rounded" />
          <Box
            component="span"
            sx={{ display: { xs: 'none', sm: 'block' } }}
            onClick={() => setOpen(!open)}
          >
            Add Followup
          </Box>
        </Button>
      </Box>
      <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <b>Date</b>
              </TableCell>
              <TableCell>
                <b>Description</b>
              </TableCell>
              <TableCell>
                <b>Remark</b>
              </TableCell>
              <TableCell>
                <b>Created By</b>
              </TableCell>
              <TableCell>
                <b>Status</b>
              </TableCell>
              <TableCell>
                <b>Action</b>
              </TableCell>
              {/* <TableCell align="center">
              <b>Action</b>
            </TableCell> */}
            </TableRow>
          </TableHead>

          <TableBody>
            {followUps.map((f) => (
              <TableRow key={f._id} hover>
                <TableCell>{new Date(f.date).toLocaleDateString()}</TableCell>

                <TableCell sx={{ maxWidth: 200 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                    }}
                  >
                    {f.description}
                  </Typography>
                </TableCell>

                <TableCell sx={{ maxWidth: 200 }}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                    }}
                  >
                    {f.remark || '-'}
                  </Typography>
                </TableCell>

                <TableCell>
                  {f.user.firstName} {f.user.lastName}
                  <Typography variant="caption" display="block">
                    {f.user.role}
                  </Typography>
                </TableCell>

                <TableCell>
                  <Chip
                    label={f.status ? 'Done' : 'Pending'}
                    color={f.status ? 'success' : 'warning'}
                    size="small"
                  />
                </TableCell>

                <TableCell>
                  <Chip
                    label={'Edit'}
                    color={f.status ? 'success' : 'warning'}
                    size="small"
                    onClick={() => {
                      setEdit(f);
                      setOpenEdit(!openEdit);
                    }}
                  />
                </TableCell>

                {/* <TableCell align="center">
              ]

                {!f.status && (
                  <IconButton size="small" color="success">
                    <CheckCircleIcon fontSize="small" />
                  </IconButton>
                )}
              </TableCell> */}
              </TableRow>
            ))}

            {followUps.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No follow-ups found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
